import axios from "./axios"

const url = "/roles"

const fetchErrorMsg = "Error fetching roles:"
const createErrorMsg = "Error creating role:"
const editErrorMsg = "Error updating role:"
const destroyErrorMsg = "Error deleting role:"

const RoleApi = () => {
	const getAll = async () => {
		try {
			const response = await axios.get(url)
			return response.data
		} catch (error) {
			console.error(fetchErrorMsg, error)
			throw error
		}
	}

	const create = async (role) => {
		try {
			const response = await axios.post(url, role)

			return response.data
		} catch (error) {
			console.error(createErrorMsg, error)
			throw error
		}
	}

	const edit = async (id, role) => {
		try {
			const response = await axios.put(`${url}/${id}`, role)

			return response.data
		} catch (error) {
			console.error(editErrorMsg, error)
			throw error
		}
	}

	const destroy = async (id) => {
		try {
			const response = await axios.delete(`${url}/${id}`)

			return response.data
		} catch (error) {
			console.error(destroyErrorMsg, error)
			throw error
		}
	}

	return {
		getAll,
		create,
		edit,
		destroy,
	}
}

export default RoleApi
